<div class="row features">
  <article id="content">

    <header>
      <h2>I’m Darcy at Daylily</h2>
    </header>
    <div class="row">
      <div class="col-3 col-12-narrower">
        <img class="image" width="90%" src="assets/images/darcy_2.jpg" alt="" />
      </div>
      <div class="col-9 col-12-narrower">
        <p>Daylily Birth and Breastfeding offers lactation education, in-home lactation support (in or near Ventura,
          California), in-office support in Midtown Ventura, childbirth preparation classes, and other support related
          to
          birth and infant feeding.</p>
        <p>Ultimately, your values and parenting instincts are the most important tools you have in birthing and feeding
          your baby, and Daylily's approach is centered around sharpening these gifts by giving you the information and
          support you need.</p>
      </div>
    </div>
    <hr>
  </article>
</div>
  <app-tln-info></app-tln-info>
  <div class="col-12 spacer"></div>
  <app-wildflower-info></app-wildflower-info>
  <div class="col-12 spacer"></div>
  <div><p><strong>Please note that travel fees or home visit fees may apply for home visits.  In-office visits are available in Midtown Ventura.</strong>
  </p></div>